import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsRetrieveVoteBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Retrieve vote</div>
          <div className="text">
            Retrieves the details of an existing vote, specified by its id.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The vote's unique identifier.",
                heading: 'id',
                subheading: 'string',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Returns a vote object, if a valid id was supplied.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/votes/retrieve</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/votes/retrieve"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d id=553c3ef8b8cdcd1501ba123b`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba123b",
  "board": {
    "created": "2017-08-30T13:32:01.000Z",
    "id": "553c3ef8b8cdcd1501ba4400",
    "name": "Feature Requests",
    "postCount": 99,
    "url": "https://your-company.canny.io/admin/board/feature-requests"
  },
  "by": null,
  "created": "2017-08-30T13:32:01.000Z",
  "post": {
    "category": {
      "id": "553c3ef8b8cdcd1501ba2234",
      "name": "Dashboard",
      "postCount": 42,
      "url": "https://your-company.canny.io/admin/board/feature-requests?category=dashboard"
    },
    "commentCount": 2,
    "eta": "February 2020",
    "id": "553c3ef8b8cdcd1501ba4444",
    "imageURLs": [],
    "jira": {
      "linkedIssues": [{
        "id": "123",
        "key": "ID-123",
        "url": "https://your-company.atlassian.net/browse/ID-123"
      }]
    },
    "score": 13,
    "status": "planned",
    "tags": [{
      "id": "553c3ef8b8cdcd1501ba3234",
      "name": "iOS",
      "postCount": 15,
      "url": "https://your-company.canny.io/admin/board/feature-requests?tags=ios"
    }],
    "title": "post-title",
    "url": "https://your-company.canny.io/admin/board/feature-requests/p/post-title"
  },
  "voter": {
    "id": "553c3ef8b8cdcd1501ba123a",
    "created": "2017-08-30T13:32:00.000Z",
    "email": "test@test.test",
    "isAdmin": false,
    "name": "Sally Doe",
    "url": "https://your-company.canny.io/admin/users/sally-doe",
    "userID": "1234"
  },
  "votePriority": "Important",
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
